// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.enterprise.events.RentalManagerEnterpriseEventTrackingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { EnterpriseListingEvent, EnterprisePageFeature } from '../..';

interface TrackCustomerListingEventParams {
  event: EnterpriseListingEvent;
  feedId: string;
  feedListingId: string;
}
interface TrackPageVisitParams {
  page: EnterprisePageFeature;
}

export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path =
  '/api/web/v1/users/enterprise/events/trackCustomerListingEvent';

/**
 * Track enterprise listing event
 */
export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent = (
  getParams: TrackCustomerListingEventParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TrackCustomerListingEventParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit_Path =
  '/api/web/v1/users/enterprise/events/trackPageVisit';

/**
 * Track enterprise page visit
 */
export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit = (
  getParams: TrackPageVisitParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TrackPageVisitParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
